module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Satin Moth")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-one-the-motherless-girl"
    }
  }, [_vm._v("Chapter One: The Motherless Girl")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-two-favourite-cousins"
    }
  }, [_vm._v("Chapter Two: Favourite Cousins")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-three-the-white-moth-appears"
    }
  }, [_vm._v("Chapter Three: The White Moth\n          Appears")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#chapter-four-laughter-turns-to-tears"
    }
  }, [_vm._v("Chapter Four: Laughter Turns to\n          Tears")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#chapter-five-the-night-vigil"
    }
  }, [_vm._v("Chapter Five: The Night Vigil")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-six-ashes-to-ashes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six: Ashes to Ashes")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-seven-the-power-of-the-witch-doctor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n          \n          Chapter Seven: The Power of the Witch Doctor")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-eight-a-storm-at-sea",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight: A Storm at Sea")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-nine-shanghai-tricks",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine: Shanghai Tricks")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-ten-treachery-unveiled",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten: Treachery Unveiled")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-eleven-the-dawn-raid",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven: The Dawn Raid")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-twelve-king-nazzor-eze",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve: King Nazzor Eze")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-thirteen-taken-into-bondage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen: Taken into\n          Bondage")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-fourteen-leaving-african-soil-forever",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen:\n          Leaving African Soil Forever")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-fifteen-shipwreck",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen: Shipwreck")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-sixteen-nabilas-curse",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen: Nabila’s Curse")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-seventeen-a-glimpse-of-the-future",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen: A\n          Glimpse of the Future")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-eighteen-the-loneliest-christmas",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen: The\n          Loneliest Christmas")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-nineteen-out-of-the-saddle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nineteen: Out of the\n          Saddle")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-twenty-warriors-foal",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty: Warrior’s Foal")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-twenty-one-the-birthday-girl",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-One: The Birthday\n          Girl")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#chapter-twenty-two-visit-to-the-museum",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Two: Visit to\n          the Museum")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#chapter-twenty-three-the-roman-holiday",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Three: The\n          Roman Holiday")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#chapter-twenty-four-the-minister-of-deliverance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Four:\n          The Minister of Deliverance")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#chapter-twenty-five-family-history",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Five: Family\n          History")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#chapter-twenty-six-the-lichen-stones",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Six: The Lichen\n          Stones")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#chapter-twenty-seven-finding-the-doll",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Seven: Finding\n          the Doll")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#chapter-twenty-eight-the-dreams-start",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Eight: The\n          Dreams Start")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#chapter-twenty-nine-trapped-in-a-storm",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Nine: Trapped\n          in a Storm")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#chapter-thirty-the-boating-accident",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty: The Boating\n          Accident")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#chapter-thirty-one-the-nightmare",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-One: The\n          Nightmare")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#chapter-thirty-two-the-generals-secret-is-revealed",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter\n          Thirty-Two: The General’s Secret Is Revealed")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#chapter-thirty-three-the-labyrinth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Three: The\n          Labyrinth")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#chapter-thirty-four-christmas-eve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Four: Christmas\n          Eve")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#chapter-thirty-five-idema",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Five: Idema")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#chapter-thirty-six-a-bright-and-beautiful-dawn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Six: A\n          Bright and Beautiful Dawn")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-206d183d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0